export default __webpack_public_path__ + "static/media/image-chair-algo-q-7-w@3x.dc886a19.webp";